import React, { useState, useEffect } from 'react';
import { geolocationService } from '../../../engine/utils/geolocation';

interface DebugInfoProps {
    fps: number;
    entityCount: number;
    level: number;
    score: number;
    lives: number;
    isVisible: boolean;
}

const DebugInfo: React.FC<DebugInfoProps> = ({
    fps,
    entityCount,
    level,
    score,
    lives,
    isVisible
}) => {
    const [countryInfo, setCountryInfo] = useState<string>('Detecting...');

    useEffect(() => {
        const detectCountry = async () => {
            try {
                await geolocationService.detectGermany();
                const countryCode = geolocationService.getCountryCode();
                setCountryInfo(countryCode || 'Unknown');
            } catch (error) {
                console.warn('Failed to detect country:', error);
                setCountryInfo('Unknown');
            }
        };

        detectCountry();
    }, []);

    if (!isVisible) return null;

    return (
        <div style={{
            position: 'absolute',
            top: '0px',
            left: '-200px',
            color: '#00FF00',
            fontSize: '14px',
            fontFamily: 'monospace',
            backgroundColor: 'rgba(0,0,0,0.7)',
            padding: '10px',
            borderRadius: '5px',
            // border: '1px solid #00FF00',
            border: '1px solid #872d03',//00FF00
            textAlign: 'left',
            minWidth: '150px'
        }}>
            <div>FPS: {fps.toFixed(1)}</div>
            <div>Entities: {entityCount}</div>
            <div>Level: {level}</div>
            <div>Score: {score}</div>
            <div>Lives: {lives}</div>
            <div>From: {countryInfo}</div>
        </div>
    );
};

export default DebugInfo; 